import { render, staticRenderFns } from "./DriverInfo.vue?vue&type=template&id=25a61645&scoped=true&"
import script from "./DriverInfo.vue?vue&type=script&lang=js&"
export * from "./DriverInfo.vue?vue&type=script&lang=js&"
import style0 from "./DriverInfo.vue?vue&type=style&index=0&id=25a61645&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a61645",
  null
  
)

export default component.exports